'use strict';

var Promise = require('./core.js')
var asap = require('asap')

module.exports = Promise
Promise.prototype.done = function (onFulfilled, onRejected) {
  var self = arguments.length ? this.then.apply(this, arguments) : this
  self.then(null, function (err) {
    asap(function () {
      throw err
    })
  })
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/google-maps-api/node_modules/promise/lib/done.js
// module id = 1468
// module chunks = 93